
import {message} from 'ant-design-vue'

export const createC = (name) => {
   message.info('这里需要实现创建组件的功能')
}

export const createV = (name) => {
  message.info('这里需要实现创建页面的功能')
}
